module.exports = __webpack_public_path__ + "ms.svg?cf3834795e20c72c4e0b8ab277b34534";